// extracted by mini-css-extract-plugin
export default {"row":"CardTrainer_row__esPYh","cell":"CardTrainer_cell__QLZ1e","photo":"CardTrainer_photo__NOVv7"};